export default "__VITE_ASSET__8ab5664d__"